<div class="propero-home propero-products">
  <section id="overview" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'PRODUCTS.HERO_EYEBROW' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'PRODUCTS.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'PRODUCTS.SUBTITLE' | translate }}</p>
      <div class="ph-hero__actions ph-hero__actions--centered">
        <a [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
          {{ 'PRODUCTS.CTA_DEMO_ADMIN' | translate }}
        </a>
        <a [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--outline ph-btn--lg">
          {{ 'PRODUCTS.CTA_DEMO_RENTER' | translate }}
        </a>
        <a href="#dashboard" class="ph-btn ph-btn--outline ph-btn--lg" (click)="scrollToSection('dashboard'); $event.preventDefault()">
          {{ 'PRODUCTS.CTA_EXPLORE' | translate }}
        </a>
      </div>
    </div>
  </section>

  <section id="demo-accounts" class="ph-section ph-section--muted ph-products-demo">
    <div class="ph-container ph-container--narrow">
      <h2 class="ph-products-demo__title">{{ 'PRODUCTS.DEMO_TITLE' | translate }}</h2>
      <p class="ph-products-demo__hint">{{ 'PRODUCTS.DEMO_HINT' | translate }}</p>
      <div class="ph-products-demo__grid">
        <article class="ph-products-demo__card ph-products-demo__card--admin">
          <span class="ph-products-demo__badge">{{ 'PRODUCTS.PORTAL_ADMIN' | translate }}</span>
          <h3 class="ph-products-demo__label">{{ 'PRODUCTS.DEMO_ADMIN_LABEL' | translate }}</h3>
          <p class="ph-products-demo__cred">{{ 'PRODUCTS.DEMO_ADMIN_USER' | translate }}</p>
          <p class="ph-products-demo__cred">{{ 'PRODUCTS.DEMO_ADMIN_PASS' | translate }}</p>
          <p class="ph-products-demo__desc">{{ 'PRODUCTS.DEMO_ADMIN_DESC' | translate }}</p>
          <a [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--sm">
            {{ 'PRODUCTS.CTA_DEMO_ADMIN' | translate }}
          </a>
        </article>
        <article class="ph-products-demo__card ph-products-demo__card--renter">
          <span class="ph-products-demo__badge">{{ 'PRODUCTS.PORTAL_RENTER' | translate }}</span>
          <h3 class="ph-products-demo__label">{{ 'PRODUCTS.DEMO_RENTER_LABEL' | translate }}</h3>
          <p class="ph-products-demo__cred">{{ 'PRODUCTS.DEMO_RENTER_USER' | translate }}</p>
          <p class="ph-products-demo__cred">{{ 'PRODUCTS.DEMO_RENTER_PASS' | translate }}</p>
          <p class="ph-products-demo__desc">{{ 'PRODUCTS.DEMO_RENTER_DESC' | translate }}</p>
          <a [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--outline ph-btn--sm">
            {{ 'PRODUCTS.CTA_DEMO_RENTER' | translate }}
          </a>
        </article>
      </div>
    </div>
  </section>

  <section class="ph-section ph-products-layout">
    <div class="ph-container ph-products-layout__inner">
      <app-products-nav
        mode="overview"
        [activeId]="activeSectionId"
        (sectionSelect)="scrollToSection($event)">
      </app-products-nav>

      <div class="ph-products-content">
        <article
          *ngFor="let feature of features; let i = index; trackBy: trackByFeatureId"
          [id]="feature.id"
          class="ph-product-feature"
          [class.ph-product-feature--reverse]="i % 2 === 1">
          <div class="ph-product-feature__copy">
            <div class="ph-product-feature__icon" aria-hidden="true">
              <i class="lni" [ngClass]="feature.icon"></i>
            </div>
            <h2 class="ph-product-feature__title">{{ feature.titleKey | translate }}</h2>
            <p class="ph-product-feature__lead">{{ feature.leadKey | translate }}</p>
            <p class="ph-product-feature__detail">{{ feature.detailKey | translate }}</p>
            <ul class="ph-product-feature__list">
              <li *ngFor="let bulletKey of feature.bulletKeys">{{ bulletKey | translate }}</li>
            </ul>
            <a [routerLink]="['/products', feature.id]" class="ph-product-feature__more">
              {{ 'PRODUCTS.MORE_LINK' | translate }}
              <i class="lni lni-arrow-right" aria-hidden="true"></i>
            </a>
          </div>

          <figure class="ph-product-feature__media">
            <app-product-screenshot
              [src]="feature.screenshot"
              [altKey]="feature.screenshotAltKey"
              (imageError)="onScreenshotError($event)">
            </app-product-screenshot>
            <figcaption class="ph-product-screenshot__caption">
              {{ feature.screenshotAltKey | translate }}
            </figcaption>
          </figure>
        </article>
      </div>
    </div>
  </section>

  <section id="cta" class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <div class="ph-page-cta">
        <h2 class="ph-page-cta__title">{{ 'PRODUCTS.CTA_TITLE' | translate }}</h2>
        <p class="ph-page-cta__text">{{ 'PRODUCTS.CTA_TEXT' | translate }}</p>
        <div class="ph-page-cta__actions">
          <a [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
            {{ 'PRODUCTS.CTA_DEMO_ADMIN' | translate }}
          </a>
          <a [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--outline ph-btn--lg">
            {{ 'PRODUCTS.CTA_DEMO_RENTER' | translate }}
          </a>
          <a routerLink="/pricing" class="ph-btn ph-btn--outline ph-btn--lg">
            {{ 'PRICING.REQUEST_OFFER_BUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
  </section>
</div>
